import {inject} from 'aurelia-property-injection';
import {DOM, bindable} from 'aurelia-framework';

export class UserPhotoValueConverter {
  toView(path) {
    return path ? `/dssb/uploadimg/${path}` : "/dssb/assets/images/person_bb.png";
  }
}

export class UserPhotoCustomAttribute {

  @inject(DOM.Element) element;

  @bindable({
    primaryProperty: true
  }) url;

  bind() {
    if (this.url) {
      this.element.style.backgroundImage = `url(/dssb/uploadimg/${this.url})`;
    }
  }

}
